import { getConfig } from '@/configs/config-accessor';
import { handleGetCollection } from '@/constants/db-collection.constants';
import ApiService from './ApiService';

// Get the API prefix from the config accessor
const getApiPrefix = () => getConfig().newApiPrefix;

export interface IBusinessInfo {
  _id: string;
  businessName: string;
  businessSize: { label: string; value: string } | null;
  roleInBusiness: string;
  userDataExtensionCollection: { label: string; value: string } | null;
  baseUrl: string | null;
  backgroundColor: string | null;
  colorWeight: number | null;
  customCss: string | null;
}

export type GetBusinessInfo_Response = IResponse<IBusinessInfo[] | null>;
export const getBusinessInfo = async () => {
  const newApiPrefix = getApiPrefix();
  return ApiService.fetchData<GetBusinessInfo_Response, DynamicGet_Body>({ 
    url: `${newApiPrefix}/dynamicmongodb/get`, 
    method: 'post', 
    data: { 
      collection: handleGetCollection('business-info') 
    } 
  });
};

export type UpdateBusinessInfo_Params = { _id: string };
export type UpdateBusinessInfo_Body = Partial<Omit<IBusinessInfo, '_id'>>;
export type UpdateBusinessInfo_Response = IResponse<IBusinessInfo | null>;
export const updateBusinessInfo = async (params: UpdateBusinessInfo_Params, body: UpdateBusinessInfo_Body) => {
  const newApiPrefix = getApiPrefix();
  return ApiService.fetchData<UpdateBusinessInfo_Response, DynamicUpdate_Body<UpdateBusinessInfo_Body>>({ 
    url: `${newApiPrefix}/dynamicmongodb/update`, 
    method: 'post', 
    data: { 
      collection: handleGetCollection('business-info'), 
      filter: { _id: { $oid: params._id } }, 
      data: body 
    } 
  });
};
